import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { SidebarComponent } from 'src/app/components/sidebar/sidebar.component';
import { Sidebar2Component } from 'src/app/components/sidebar2/sidebar2.component';
import { Sidebar3Component } from 'src/app/components/sidebar3/sidebar3.component';
import { NgbModalModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { Routes, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridList, MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { BreadcrumbComponent } from 'src/app/components/breadcrumb/breadcrumb.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TypeaheadTextboxComponent } from 'src/app/components/typeahead-textbox/typeahead-textbox.component';
import { MatTableModule } from '@angular/material/table';
// import { MaterialModule, MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MaterialModule } from '../employee/shared/angular-material/material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    LoaderComponent,
    BreadcrumbComponent,
    TypeaheadTextboxComponent,
    Sidebar2Component,
    Sidebar3Component,
  ],
  imports: [
    CommonModule,
    // NgbTooltipModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    // NgbTooltipModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatRadioModule,
    MatChipsModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    SlickCarouselModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    NgbModule,
    MatGridListModule,
    MatMenuModule,
    MatBadgeModule,
    InfiniteScrollModule,
    MatTableModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    ScrollingModule
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    LoaderComponent,
    // NgbTooltipModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    NgbTooltipModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatRadioModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    SlickCarouselModule,
    ReactiveFormsModule,
    MatGridList,
    BreadcrumbComponent,
    InfiniteScrollModule,
    TypeaheadTextboxComponent,
    MatExpansionModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule

  ]
})
export class SharedModule { }
